import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc94051a&scoped=true"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=dc94051a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc94051a",
  null
  
)

export default component.exports